import { TermsOfUseModal } from "./TermsOfUseModal";

export default TermsOfUseModalimport { TermsOfUseModal } from "./TermsOfUseModal";

export default TermsOfUseModal